import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lmM3uKeywordsApi = createApi({
  reducerPath: 'lmM3uKeywordsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['M3U keywords'],
  endpoints: builder => ({
    getM3uKeywords: builder.query({
      query: (params) => ({
        url: `/links/m3u-keywords/`,
        params,
      }),
      providesTags: ['M3U keywords'],
    }),

    createM3uKeyword: builder.mutation({
      query: (data) => ({
        url: '/links/m3u-keywords/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['M3U keywords'],
    }),
    updateM3uKeyword: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/m3u-keywords/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['M3U keywords'],
    }),
    getM3uKeywordById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/m3u-keywords/${id}/`,
        params,
      }),
      providesTags: ['M3U keywords']
    }),
  }),
});

export const {
  useGetM3uKeywordsQuery,
  useLazyGetM3uKeywordsQuery,
  useCreateM3uKeywordMutation,
  useUpdateM3uKeywordMutation,
  useGetM3uKeywordByIdQuery
} = lmM3uKeywordsApi;
